// src/fonts.js

const fonts = {
  primary: "'Roboto', sans-serif",
  heading: "'Montserrat', sans-serif",
};

export default fonts;
